/** Terrain & biome domain model. A generated map is a flat, row-major grid of
 * tiles plus derived per-tile fields. */
import type { Deposit } from './resources.js';

/** Coarse terrain class — drives movement, buildability and rendering. */
export enum TerrainType {
  DeepWater = 'deep_water',
  ShallowWater = 'shallow_water',
  Sand = 'sand',
  Grass = 'grass',
  Forest = 'forest',
  Dirt = 'dirt',
  Rock = 'rock',
  Snow = 'snow',
  Swamp = 'swamp',
}

/** Higher-level biome, derived from height/moisture/temperature. */
export enum Biome {
  Ocean = 'ocean',
  Lake = 'lake',
  Beach = 'beach',
  Meadow = 'meadow',
  Forest = 'forest',
  Mountain = 'mountain',
  Snow = 'snow',
  Swamp = 'swamp',
  Desert = 'desert',
}

/** Impassable movement cost sentinel. */
export const IMPASSABLE = Number.POSITIVE_INFINITY;

/** A single map cell. Structure-of-arrays is used in the generator for cache
 * efficiency; this interface documents the logical shape of one tile. */
export interface Tile {
  readonly terrain: TerrainType;
  readonly biome: Biome;
  /** Normalised elevation [0, 1]. */
  readonly height: number;
  /** Normalised moisture [0, 1]. */
  readonly moisture: number;
  /** Normalised temperature [0, 1]. */
  readonly temperature: number;
  /** Integer elevation step used for the isometric vertical offset. */
  readonly elevation: number;
  /** Whether a building may be placed here. */
  readonly buildable: boolean;
  /** Movement cost to traverse; IMPASSABLE means blocked. */
  readonly moveCost: number;
  /** Natural deposit present on the tile, if any. */
  readonly deposit: Deposit;
}
